"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// (C) 2020 GoodData Corporation
exports.TOOLTIP_TEXT = "tooltipText";
exports.LOCATION = "location";